import ReactSelect from "components/Form/Select/Select";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Container, FormGroup, Input, Label, Modal, Row, Form, ModalBody } from "reactstrap";
import DataTableEcommerce from './DataTableEcommerce/DataTableEcommerce';
import FormTipoPreco from "./FormTipoPreco/FormTipoPreco";
import useForm from "lib/useForm";
import NumberFormat from "react-number-format";
import './precosEcommerce.css'
import rotas from "services/rotas";
import rest from 'lib/rest';
import Swal from "sweetalert2";
import FormProdutosEcommerce from "./FormProdutosEcommerce/FormProdutosEcommerce";

const PrecosEcommerce = () => {

  const colunas = [{
    dataField: '',
    text: '',
    headerStyle: { cursor: 'default' },
    width: '50px',
    checkbox: true,
    visible: true
  }, {
    dataField: 'cod_barras',
    text: 'Código',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }, {
    dataField: 'produto',
    text: 'Produto',
    headerStyle: { cursor: 'default' },
    width: '250px',
    checkbox: false,
    visible: true
  }, {
    dataField: 'prod_prvenda',
    text: 'Pr.Venda',
    headerStyle: { cursor: 'default' },
    width: '120px',
    checkbox: false,
    visible: true
  }, {
    dataField: 'prod_prpromocao',
    text: 'Pr.Promoção',
    headerStyle: { cursor: 'default' },
    width: '120px',
    checkbox: false,
    visible: true
  }, {
    dataField: '',
    text: '%',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }, {
    dataField: '',
    text: 'R$',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }, {
    dataField: '',
    text: '%',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }, {
    dataField: '',
    text: 'R$',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }, {
    dataField: '',
    text: 'Venda',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }, {
    dataField: '',
    text: 'Promoção',
    headerStyle: { cursor: 'default' },
    width: '80px',
    checkbox: false,
    visible: true
  }]

  const data = [{
    produto_id: 1,
    produto: 'TESTE 1',
    prod_prvenda: '3.50',
    prod_prpromocao: '2.90'
  }]

  const listaTipoFiltro = [{
    id: 1,
    title: 'Produto'
  }, {
    id: 2,
    title: 'Categoria'
  }]

  const initialForm = {
    tipo_preco: {
      id: '',
      title: ''
    },categoria_id: {
      id: '',
      title: ''
    },filial_id: {
      id: '',
      title: ''
    },
    desc_porc:'0',
    valor:'0',
    integra_promocao:'N',
    regra_pmc:'N'
  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(initialForm);
  const [listaTipoPreco, setListaTipoPreco] = useState([]);
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaLojas, setListaLojas] = useState([]);
  const [openModal,setOpenModal] = useState(false);

  useEffect(()=>{
    listarTipoPreco();
    listarCategorias();
    listarLojas();
  },[])

  const listarTipoPreco = () =>{
    const url = rotas.ecommerceTipoPreco;

    const retorno = rest.get(url);
    
    retorno.then(ret=>{
      if((ret.success) && (ret.success == 'S')){
        let lista = [];
        
        ret.lista.map(ret=>{
          lista.push({
            id:ret.tipo_preco_id,
            title:ret.descricao
          })
        })
        setListaTipoPreco(lista);
      }
    })

  }

  const listarCategorias = ()=>{
    const url = rotas.categoriaProduto;

    const retorno = rest.get(url);

    retorno.then(ret=>{
      if((ret.success) && (ret.success == 'S')){
        let lista = [];

        ret.lista.map(lst=>{
          lista.push({
            id:lst.categoria_id,
            title:lst.categoria
          })
        })
        setListaCategoria(lista);
      }
    })
  }

  const listarLojas = () =>{
    const url = rotas.lojas;

    const retorno = rest.get(url);

    retorno.then(ret=>{
      if((ret.success) && (ret.success == 'S')){
        let lista = [];

        ret.lista.map(lst=>{
          lista.push({
            id:lst.filial_id,
            title:lst.fantasia
          })
        })
        setListaLojas(lista);
      }
    }) 
  }

  const precificarEcommerce = ()=>{  
  
    if(form.filial_id.id == ''){
      Swal.fire('Atenção','Por favor selecione a loja a ser configurada!','warning');
      return;
    }

    if(form.categoria_id.id == ''){
      Swal.fire('Atenção','Por favor selecione a categoria a ser configurada!','warning');
      return;
    }

    if(form.tipo_preco.id == ''){
      Swal.fire('Atenção','Por favor selecione o tipo do preço a ser configurado!','warning');
      return;
    }

    const url = rotas.ecommercePrecificar;
    
    const retorno = rest.post(url,form);

    retorno.then(ret=>{
      if(ret.success && ret.success == 'S'){
        Swal.fire('Sucesso','Registro Gravado com Sucesso!','success');
      }else{
        Swal.fire('Erro','Erro na gravação dos dados!','error');
      }
    })
  }

  const closeModal = () =>{
    setOpenModal(false)
  }

  return (<>
    <div className="content">
      <Modal
        isOpen={openModal}        
        size='xl'
      >
        <FormProdutosEcommerce closeModal={closeModal}></FormProdutosEcommerce>
      </Modal>
      <Container>        
        <Row>
          <Col md="12" className="p-0">
            <Card>
              <CardHeader>
                <CardTitle>PRECIFICAÇÃO E-COMMERCE</CardTitle>
              </CardHeader>
              <CardBody>
                <Row>

                <Col md='4'>
                    <FormGroup>
                      <ReactSelect
                        name="filial_id"
                        label="Loja"
                        placeholder="Selecione"
                        options={listaLojas}
                      // defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                        onChange={onChangeSelect('filial_id')}
                      // erro={form.fornecedor_id > 0 ? false : true}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <ReactSelect
                        name="tipo-preco"
                        label="Tipo Preço"
                        placeholder="Selecione"
                        options={listaTipoPreco}
                      // defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                        onChange={onChangeSelect('tipo_preco')}
                      // erro={form.fornecedor_id > 0 ? false : true}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md='4'>
                    <FormGroup>
                      <ReactSelect
                        name="categoria"
                        label="Categoria"
                        placeholder="Selecione"
                        options={listaCategoria}
                      // defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                        onChange={onChangeSelect('categoria_id')}
                      // erro={form.fornecedor_id > 0 ? false : true}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                </Row>

                <Row>
                  <Col md='3'>
                    <FormGroup>
                      <Label for="desc_porc">Porcent. %</Label>
                      <NumberFormat
                        required
                        name="desc_porc"
                        id="desc_porc"
                        placeholder="0.00"
                        value={form.desc_porc.replace('.', ',')}
                       
                        onChange={onChange('desc_porc')}
                        maxLength={20}
                        decimalScale={2}
                        allowNegative={false}
                        className={"form-control"}
                        // prefix={"R$ "}
                        decimalSeparator={','}
                        fixedDecimalScale
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="valor">Valor a ser adicionado R$</Label>
                      <NumberFormat
                        required
                        name="valor"
                        id="valor"
                        placeholder="0.00"
                        value={form.valor.replace('.', ',')}
                        onChange={onChange('valor')}
                        maxLength={20}
                        decimalScale={2}
                        allowNegative={false}
                        className={"form-control"}
                        prefix={"R$ "}
                        decimalSeparator={','}
                        fixedDecimalScale
                      />
                    </FormGroup>
                  </Col>


                  <Col md='6'>
                    <Col className="check-box-params">
                      {/* <Row className="card-1 pb-3 pt-4"> */}
                      {/* <Col className="d-flex border"> */}
                      {/* <span className="tag-card">Status do Produto</span> */}

                      <FormGroup check inline
                      
                      >
                        <Label check className="label-check-box-params">
                          <Input
                            type="checkbox"
                            id="integra_promocao"
                            onClick={onChange('integra_promocao')}
                          //defaultChecked={form.prod_ativo === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />Integra Promoção?
                        </Label>
                      </FormGroup>{" "}

                      <FormGroup check inline
                      
                      >
                        <Label check className="label-check-box-params">
                          <Input
                            type="checkbox"
                            id="regra_pmc"
                            onClick={onChange('regra_pmc')}
                          //defaultChecked={form.prod_ativo === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />Regra PMC
                        </Label>
                      </FormGroup>{" "}

                      {/* </Col> */}
                      {/* </Row> */}
                    </Col>
                  </Col>
                </Row>

                <Col className="text-center p-3">
                  <Button className="mb-0 mt-0" color="success" size="md" onClick={precificarEcommerce}>Salvar</Button>
                  {/* <Button type="button" className="mb-0 mt-0" color="danger" size="md" >Excluir</Button> */}
                  <Button type="button" className="mb-0 mt-0" color="info" size="md" onClick={()=>{setOpenModal(true)}}>Por Produto</Button>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>
    </div>

  </>)
}

export default PrecosEcommerce;